"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contact = Contact;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Highlight = _interopRequireDefault(require("../Highlight"));
var _excluded = ["avatar", "name", "email", "highlightWord", "onClick", "textSize", "className"];
var _default = exports["default"] = function _default(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    contacts = _ref.contacts;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-full"
  }, !!label && /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4 mb-2 text-xs font-light font-semibold uppercase text-gray-light"
  }, label), /*#__PURE__*/_react["default"].createElement("div", null, contacts.map(function (each, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "px-4 my-3 hover:bg-secondary"
    }, each);
  })));
};
function Contact(_ref2) {
  var avatar = _ref2.avatar,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? '' : _ref2$name,
    _ref2$email = _ref2.email,
    email = _ref2$email === void 0 ? '' : _ref2$email,
    _ref2$highlightWord = _ref2.highlightWord,
    highlightWord = _ref2$highlightWord === void 0 ? '' : _ref2$highlightWord,
    _ref2$onClick = _ref2.onClick,
    onClick = _ref2$onClick === void 0 ? _noop["default"] : _ref2$onClick,
    textSize = _ref2.textSize,
    className = _ref2.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('flex items-center py-2 cursor-pointer', className),
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      onClick(e);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-4"
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 leading-tight overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement(_Highlight["default"], {
    keyword: highlightWord,
    className: (0, _classnames["default"])('text-sm text-dark subpixel-antialiased truncate', textSize),
    highlightClassName: "font-semibold"
  }, name), /*#__PURE__*/_react["default"].createElement(_Highlight["default"], {
    keyword: highlightWord,
    className: (0, _classnames["default"])('text-xs text-gray-medium tracking-wide subpixel-antialiased truncate', textSize),
    highlightClassName: "font-semibold"
  }, email)));
}
//# sourceMappingURL=index.js.map